import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import { MoreText, SubTitle } from '~/pages/Main/index.styled';
import { FlexStack, Icon } from '~/components/atomic';
import HorizontalCardSlide from '~/components/common/HorizontalCardSlide/HorizontalCardSlide';
import { useGetSearchCharacterListQuery } from '~/features/character';
import { CHARACTER_FETCH_SIZE } from '~/features/character/useGetSearchCharacterListQuery';
import { useCharacterLikeActions, useCreateChatRoom } from '~/hooks';
import { PAGE_ROUTE } from '~/constants';

export default function ExploreAllCharacters() {
  const navigate = useNavigate();

  const { data } = useGetSearchCharacterListQuery({});

  const { handleLikeClick } = useCharacterLikeActions();
  const { handleCreateRoomClick, isCreateRoomPending } = useCreateChatRoom();

  return (
    <>
      {/* {isCreateRoomPending && <FullScreenLoading />} */}

      <FlexStack spacing={16}>
        <div
          css={css`
            display: flex;
            justify-content: space-between;
          `}
        >
          <SubTitle>Chat</SubTitle>
          <MoreText onClick={() => navigate(PAGE_ROUTE.MORE_ONE_ON_ONE)}>
            More <Icon iconName='ArrowRight' size={20} />
          </MoreText>
        </div>
        <div>
          <HorizontalCardSlide
            imageWidth={130}
            images={data.pages.splice(0, CHARACTER_FETCH_SIZE)}
            handleCardClick={handleCreateRoomClick}
            handleLikeClick={handleLikeClick}
          />
        </div>
      </FlexStack>
    </>
  );
}
